import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class ProductCartQuantityService {
    private get CART_QUANTITY_SELECTOR(): string {
        return "js-pcg-cart-qty";
    }

    public updateCartQuantity(quantity: number): void {
        const cartQuantity = document.getElementsByClassName(this.CART_QUANTITY_SELECTOR)[0];
        if (cartQuantity) {
            cartQuantity.textContent = `(${quantity})`;
        }
    }
}
